

















import { Component, Vue } from 'vue-property-decorator'
import { EventbusType, IEventbus } from '@movecloser/front-core'

import { Inject } from '@plugin/inversify'

/**
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
 * @author Javlon Khalimjonov <javlon.khalimjonov@movecloser.pl>
 */
@Component<Layout>({
  name: 'Layout',

  mounted (): void {
    this.attachListeners()
  }
})
export class Layout extends Vue {
  @Inject(EventbusType)
  private readonly eventBus!: IEventbus

  /**
   * Determines whether the middle section should be dimmed.
   */
  public isMiddleDimmed: boolean = false

  /**
   * Handles the `@click` event on the `.layout__middle__overlay`.
   */
  public onOverlayClick (): void {
    if (this.isMiddleDimmed) this.closeSidebar()
  }

  /**
   * Attaches all the needed event listeners.
   */
  private attachListeners (): void {
    this.eventBus.handle('ui:layout.dim', this.dimMiddle)
    this.eventBus.handle('ui:layout.lit', this.litMiddle)
  }

  /**
   * Dims the middle section.
   */
  private dimMiddle (): void {
    this.isMiddleDimmed = true
  }

  /**
   * Closes the sidebar.
   */
  private closeSidebar (): void {
    this.eventBus.emit('ui:sidebar.close')
  }

  /**
   * Lits the middle section up.
   */
  private litMiddle (): void {
    this.isMiddleDimmed = false
  }
}

export default Layout
